const generateActivity = (activities) => {
  return activities[Math.floor(Math.random() * activities.length)];
};

export default generateActivity;
